import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import LiteraturePage from './pages/LiteraturePage'
import QuestionPage from './pages/QuestionPage'
import HistoryPage from './pages/HistoryPage'
import APIConfigPage from './pages/APIConfigPage'
import AnalyticsPage from './pages/AnalyticsPage'
import Header from './components/Header'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/literature" element={<LiteraturePage />} />
            <Route path="/questions" element={<QuestionPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/api-config" element={<APIConfigPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
          </Routes>
        </main>
        <footer className="bg-gray-800 text-white py-6">
          <div className="container mx-auto px-4 text-center">
            <p className="text-sm">
              IBO Question Maker - AI生物竞赛题目生成器
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Powered by AI | Built with React, Vite & Cloudflare Workers
            </p>
          </div>
        </footer>
      </div>
    </ErrorBoundary>
  )
}

export default App
